//Document ready
$(function() {
	historyListSlick();
  historyListWidth();
  $(window).resize(function() {
    historyListWidth();
  });
});

function historyListSlick() {
  $('.history-list').slick({
    infinite: false,
    prevArrow: $('.history-arrows .slick-prev'),
    nextArrow: $('.history-arrows .slick-next'),
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}
function historyListWidth(){
  var historyWidth = $('.history-list').width();
  $('.history-list').css('width', historyWidth + 360);
}
